import axios from "axios";
import OSS from "ali-oss";
import {
  Notification,
  Loading
} from "element-ui";
import store from "@/vuex";
/*import {
  dateToFormat
} from "@/config/_filter"
*/
let loadingInstance; // loading组件

/*
function getRepairFileName(file) {
  return `${Math.floor(Math.random() * 100000 + 1)}-${file.name}`;

}
*/

const uploadFileBlob = async function (file, path, cb, isSts = false) {
  loadingInstance = Loading.service({
    lock: true,
    text: "Loading",
    spinner: "el-icon-loading",
    background: "rgba(0, 0, 0, 0.7)"
  });
  if (isSts) {
    const stsRes = await axios.get('/api/get/aliyun/sts', {
      headers: {
        "Authorization": store.getters.token,
        "X-Requested-With": "XMLHttpRequest"
      }
    }).catch(err => {
      Notification({
        title: "警告",
        message: err,
        type: "warning"
      });
      loadingInstance.close();
      return new Promise(function (resolve, reject) {
        reject(new Error("获取token失败"));
      });
    })
    if (stsRes) {
      store.commit('SET_STS_CLIENT_OSS', new OSS({
        region: "oss-cn-zhangjiakou",
        accessKeyId: stsRes.data.AccessKeyId,
        accessKeySecret: stsRes.data.AccessKeySecret,
        stsToken: stsRes.data.SecurityToken,
        bucket: 'wugetestcase',
        secure: true
      }));
    }
  } else {
    try {
      // 填写Object完整路径。Object完整路径中不能包含Bucket名称。
      // 您可以通过自定义文件名（例如exampleobject.txt）或目录（例如mytestdoc/exampleobject.txt）的形式实现将文件上传到当前Bucket或Bucket中的指定目录。
      let result = await store.state.resource.stsClientOss.put(path, file);
      cb(result);
      loadingInstance.close();
    } catch (e) {
      console.log(e);
    }
  }
};

export default uploadFileBlob;